import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { PI_NUMBER } from "../../constants";

export default class RadialMeter extends Component {
    static propTypes = {
        diameter: PropTypes.number,
        strokeWidth: PropTypes.number,
        value: PropTypes.number,
        className: PropTypes.string
    }

    static defaultProps = {
        diameter: 200,
        strokeWidth: 8,
        value: 0,
        className: ""
    }

    constructor(props) {
        super(props);

        this.radius = (this.props.diameter / 2) - (this.props.strokeWidth / 2)
    }

    calculateDashPosition(value = 1) {
        return 2 * PI_NUMBER * this.radius * value
    }

    render() {
        return <div className={"radial-meter " + this.props.className}>
            <svg width={this.props.diameter}
                 height={this.props.diameter}
                 viewBox={`0 0 ${this.props.diameter}
                 ${this.props.diameter}`}
                 className={"progress"}>
                <circle cx={this.props.diameter / 2}
                        cy={this.props.diameter / 2}
                        r={this.radius}
                        fill="none"
                        strokeWidth={this.props.strokeWidth}
                        className={"progress_circle"}/>
                <circle cx={this.props.diameter / 2}
                        cy={this.props.diameter / 2}
                        r={this.radius}
                        fill="none"
                        strokeWidth={this.props.strokeWidth}
                        strokeDasharray={this.calculateDashPosition()}
                        strokeDashoffset={this.calculateDashPosition(1 - this.props.value)}
                        className={"progress_value"} />

            </svg>
            {this.props.children}
        </div>
    }

}


// WEBPACK FOOTER //
// ./src/scripts/reusable/RadialMeter/RadialMeter.jsx